/* ==========================================================================
   VELLO CUSTOM JS
   Slick init code for each section lives INSIDE that section's Liquid file
   so per-section settings from the theme editor flow through cleanly.
   This file contains only globally shared behavior.
   ========================================================================== */

(function () {
  /**
   * Custom play button handler for all Vello video cards on the page.
   * Pattern: click the play button → pauses all other videos,
   * plays this one, hides its button. When the video pauses or ends,
   * the button shows again. Mirrors Vello's behavior 1:1.
   */
  function bindVelloVideoButtons() {
  var playButtons = document.querySelectorAll(
    '.video-testimonials .custom-play-button, ' +
    '.vello-product-video-section .custom-play-button'
  );

  var videos = document.querySelectorAll(
    '.video-testimonials video, ' +
    '.vello-product-video-section video'
  );

  playButtons.forEach(function (btn) {
    if (btn.dataset.velloBound === '1') return;
    btn.dataset.velloBound = '1';

    var wrapper = btn.closest('.video-wrapper');
    var video = wrapper ? wrapper.querySelector('video') : null;
    var poster = wrapper ? wrapper.querySelector('.video-poster-fallback') : null;

    if (!video) return;

    btn.addEventListener('click', function () {
      videos.forEach(function (v) {
        if (v !== video) {
          v.pause();
          v.controls = false;

          var otherWrapper = v.closest('.video-wrapper');
          var otherBtn = otherWrapper ? otherWrapper.querySelector('.custom-play-button') : null;
          var otherPoster = otherWrapper ? otherWrapper.querySelector('.video-poster-fallback') : null;

          if (otherBtn) otherBtn.style.display = 'block';
          if (otherPoster) otherPoster.style.display = 'block';
        }
      });

      if (poster) poster.style.display = 'none';

      video.controls = true;

      var playPromise = video.play();

      btn.style.display = 'none';

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          btn.style.display = 'block';
          video.controls = false;
          if (poster) poster.style.display = 'block';
        });
      }
    });

    video.addEventListener('play', function () {
      btn.style.display = 'none';
      video.setAttribute('data-ready', '');
      if (poster) poster.style.display = 'none';
    });

    video.addEventListener('pause', function () {
      btn.style.display = 'block';
      if (poster) poster.style.display = 'block';
    });

    video.addEventListener('ended', function () {
      btn.style.display = 'block';
      video.controls = false;
      if (poster) poster.style.display = 'block';
    });
  });
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindVelloVideoButtons);
  } else {
    bindVelloVideoButtons();
  }

  // Rebind when Slick clones slides (infinite mode) or theme editor reloads a section
  document.addEventListener('shopify:section:load', bindVelloVideoButtons);

  // Also rebind after Slick has cloned DOM (slide clones lose event listeners)
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('init.slick reInit.slick', function () {
      setTimeout(bindVelloVideoButtons, 50);
    });
  }
})();

/* ==========================================================================
   Global CTA button behavior
   Product-page CTAs smoothly scroll back to the main ATC area. Other pages keep
   the bundle-offer behavior when present, otherwise scroll to the top.
   Add-to-Cart buttons and off-page links keep their native behavior.
   ========================================================================== */
(function () {
  function getBundlesTarget() {
    return document.getElementById('kaching-bundles') ||
      document.querySelector('[data-kaching-bundles-target]');
  }

  function getProductAtcTarget() {
    return document.querySelector('product-form[data-main="true"]') ||
      document.querySelector('.main-product-section product-form.main-product-form') ||
      document.querySelector('.main-product-section .main-product-form') ||
      document.querySelector('.main-product-section .main-product-atc');
  }

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function isAddToCartContext(el) {
    // Inside any product-form web component = ATC flow
    if (el.closest && el.closest('product-form')) return true;
    // Shrine / Dawn ATC button IDs and classes
    if (el.id && /^(ProductSubmitButton|SectionAtcBtn)/i.test(el.id)) return true;
    if (el.classList.contains('product-form__submit')) return true;
    if (el.classList.contains('main-product-atc')) return true;
    // Fallback: button text contains "add to cart" / "add to bag"
    var txt = (el.textContent || '').trim().toLowerCase();
    if (txt.includes('add to cart') || txt.includes('add to bag')) return true;
    return false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cta-button');
    if (!btn) return;
    if (isAddToCartContext(btn)) return;

    var href = btn.getAttribute('href');

    // Explicit off-site/off-page URL: let the browser follow it normally.
    if (href && href !== '#' && href.charAt(0) !== '#') return;

    if (isProductPage()) {
      var productAtcTarget = getProductAtcTarget();
      if (productAtcTarget) {
        e.preventDefault();
        productAtcTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    // If the merchant set an explicit on-page anchor on non-product pages, honor it.
    if (href && href !== '#' && href.charAt(0) === '#') {
      var targetEl = document.querySelector(href);
      if (targetEl) {
        e.preventDefault();
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    // Default: smooth-scroll to the bundle offer when available, otherwise top of page
    e.preventDefault();
    var bundlesTarget = getBundlesTarget();
    if (bundlesTarget) {
      bundlesTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
